<template>
    <sign-modal 
        @closeModal="closeModal"
        @saveSign="saveSign"
        v-if="isModal"
    />
    <div name="contract" class="contract" id="contract3" v-else>
        <loading v-if="isLoading" />
        <close-button 
            @close="closeContract"
        />
        
        <img src="../../../assets/revisit_contract_step_2.png" class="step" />

        <span class="title">위임장 내용을 확인 후<br>서명해 주세요</span>
        <div v-if="imageUrl === null" ref="container" class="image-container" id="contract1" style="margin-top: 20px;margin-bottom: 0px;">
            <span ref="text_start_1_year" class="inner-image-start-1-year">{{ delegateWithAddition.started_at.substring(0, 4) }}</span>         
            <span ref="text_start_1_month" class="inner-image-start-1-month">{{ delegateWithAddition.started_at.substring(5, 7) }}</span>
            <span ref="text_start_1_day" class="inner-image-start-1-day">{{ delegateWithAddition.started_at.substring(8, 10) }}</span>
            <span ref="text_end_year" class="inner-image-end-year">{{ delegateWithAddition.expired_at.substring(0, 4) }}</span>
            <span ref="text_end_month" class="inner-image-end-month">{{ delegateWithAddition.expired_at.substring(5, 7) }}</span>
            <span ref="text_end_day" class="inner-image-end-day">{{ delegateWithAddition.expired_at.substring(8, 10) }}</span>
            <span ref="text_start_2_year" class="inner-image-start-2-year">{{ delegateWithAddition.started_at.substring(0, 4) }}</span>
            <span ref="text_start_2_month" class="inner-image-start-2-month">{{ delegateWithAddition.started_at.substring(5, 7) }}</span>
            <span ref="text_start_2_day" class="inner-image-start-2-day">{{ delegateWithAddition.started_at.substring(8, 10) }}</span>
            <span ref="text_sign_name" class="inner-image-sign-name">{{ delegateWithAddition.writer_name }}</span>
            <span ref="text_name" class="inner-image-name" >{{ draftProfile.name }}</span>
            <span ref="text_registration_number" class="inner-image-registration-number">{{draftProfile.registration_number }}</span>
            <span ref="text_proxy_name" class="inner-image-proxy-name" v-if="delegateWithAddition.writer_type === 1" >{{ delegateWithAddition.writer_name }}</span>
            <span ref="text_proxy_birth" class="inner-image-proxy-birth" v-if="delegateWithAddition.writer_type === 1">{{ delegateWithAddition.writer_birth }}</span>
            <span ref="text_proxy_relation"  v-if="delegateWithAddition.writer_type == 1" class="inner-image-proxy-relation" >{{ convertRelation(delegateWithAddition.writer_relationship) }}</span>
            <span ref="text_phone_number" class="inner-image-phone-number">{{ delegateWithAddition.writer_phone_number }}</span>
            <img ref="image_sign" class="overlay-button-none" :src="signImageUrl" v-if="signImageUrl !== null" />
            <img v-if="draftProfile.diabetes_type === 'TYPE1'" ref="image" src="../../../assets/contract1.png" class="responsive-image" @load="onImageLoad" /> 
            <img v-else-if="draftProfile.diabetes_type === 'SELF_CATHETER'" ref="image" src="../../../assets/contract3.png" class="responsive-image" @load="onImageLoad"/>  
            <img v-else ref="image" src="../../../assets/contract2.png" class="responsive-image" @load="onImageLoad"/> 
        </div>
        <div v-else ref="container" class="image-container" id="contract2" style="margin-top: 20px;margin-bottom: 0px; width: 100%;">
            <img class="responsive-image" :src="imageUrl" />
            <div class="overlay-button" @click="signing" v-if="signImageUrl === null">                
                <span>서명하기</span>
            </div>
        </div>
        
        <div class="change" v-if="signImageUrl !== null">
            <div style="width: 100%; text-align: right;">
                <span class="reset-button" @click="resetSign" >서명 초기화</span>
            </div>
            <div style="text-align: center;">
                <span class="change-info-text">
                    <strong>💡 변경된 내용이 있습니다.</strong>
                    <br>서명 변경은 초기화 버튼을 눌러주세요.
                </span>
            </div>

        </div>
        <div style="min-height: 150px;">

        </div>
        <div class="footer-button-area" >
            <div class="button-back" @click="back">
                이전
            </div>
            <div class="button-sign" @click="signing" v-if="!signImageUrl" >
                서명 시작하기
            </div>
            <div class="button-sign-active" v-else @click="next">
                다음 단계
            </div>
        </div>
    </div>
</template>

<script>

import SignModal from '@/components/modals/SignModal'
import html2canvas from 'html2canvas'
import {mapState} from 'vuex';

import CloseButton from '@/components/atoms/CloseButton';
import Loading from '@/components/molecules/Loading';

export default {
    name: 'contract',
    computed: mapState(['delegateWithAddition', 'draftProfile', 'pre_delegation_info']),
    data: function()
    {
        return {
            isModal: false,
            fontSize: 16,
            name_font_size: 14,
            registration_number_font_size: 14,
            proxy_name_font_size: 14,
            proxy_birth_font_size: 14,
            proxy_relation_font_size: 14,
            phone_number_font_size: 14,
            start_1_year_font_size: 14,
            start_1_month_font_size: 14, 
            start_1_day_font_size: 14,
            end_year_font_size: 14,
            end_month_font_size: 14,
            end_day_font_size: 14,
            end_font_size: 14, 
            start_2_year_font_size: 14, 
            start_2_month_font_size: 14,
            start_2_day_font_size: 14,
            sign_name_font_size: 14,
            sign_size: 100 ,
            imageUrl: null,
            isLoading: false,
            // sign_file: null,
            signImageUrl: null,
        }
    },  
    components: {
        SignModal,
        CloseButton,
        Loading
    },
    mounted: function()
    {
        document.body.style.overflow = 'hidden'; // 스크롤 비활성화
        // 화면 크기 변화 시 버튼 위치를 조정
        // window.addEventListener("resize", this.updateButtonPosition);
        this.topFunction();
    },
    beforeDestroy: function(){
        // window.removeEventListener("resize", this.updateButtonPosition);
    },
    methods: {
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        resetSign: function()
        {
            this.signImageUrl = null;
            this.imageUrl = null;            

        },
        getImageUrl: function()
        {
            let _this = this;
            html2canvas(document.getElementById('contract1')).then(canvas => {
                // _this.onSaveAs(canvas.toDataURL('image/png'), `contract.png`)      
                _this.imageUrl = canvas.toDataURL('image/png');
                // const blob = _this.dataURLToBlob(canvas.toDataURL('image/png'));
                // const file = new File([blob], fileName, { type: "image/png" });
                // this.files.delegation_docs_file = file;
                // console.log(file);
            })
        },
        async onImageLoad() {

            this.isLoading = true;
            const el = this.$refs.image;
            // 1) Vue DOM 업데이트 완료
            await this.$nextTick();
            // 2) 최소 한 프레임(실제 페인트) 대기
            await new Promise(requestAnimationFrame);

            // 3) 실제로 보일 수 있는 상태가 될 때까지 최대 N프레임 대기
            // 아직 화면에 안 보이면 프레임 반복 체크 (최대 20번)
            let tries = 0;
            while (tries < 20) {
                const rect = this.$refs.image.getBoundingClientRect();
                if (rect.width > 0 && rect.height > 0) break;
                await new Promise(requestAnimationFrame);
                tries++;
            }

            await new Promise(resolve => setTimeout(resolve, 100));
            // const rec2 = this.$refs.image.getBoundingClientRect();
            // console.log('렌더링후 크기:', rec2.width, rec2.height);
            // 4) 여기 도달하면 화면에 실제로 보이는 상태 (레이아웃/페인트 완료)
            // const rect = el.getBoundingClientRect();
            // alert('렌더링 완료 크기:', rect.width, rect.height)
            // console.log('렌더링 완료 크기:', rect.width, rect.height);
            this.isLoading = false;
            // 여기에 이후 로직 실행
            this.getImageUrl(); // 예시
        },
        _isActuallyVisible(el) {
            if (!el || !el.isConnected) return false;

            const style = window.getComputedStyle(el);
            if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) {
            return false;
            }

            // 조상에 display:none이 있으면 offsetParent가 null인 경우가 많음
            if (el.offsetParent === null && style.position !== 'fixed') {
            return false;
            }

            const rect = el.getBoundingClientRect();
            // 레이아웃이 0이면 아직 배치/페인트 전일 가능성 큼
            return rect.width > 0 && rect.height > 0;
        },
        convertRelation: function(relation)
        {
            if(relation === 0)
            {
                return '부'
            }
            else if(relation === 1)
            {
                return '모'
            }
            else if(relation === 2)
            {
                return '자녀'
            }
            else if(relation === 3)
            {
                return '손자'
            }
            else if(relation === 4)
            {
                return '손녀'
            }
            else if(relation === 5)
            {
                return '기타'
            }
        },
        closeContract: function()
        {
            document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('onClose')
        },
        dataURLToBlob:function (dataURL) {
            const binaryString = atob(dataURL.split(",")[1]);
            const array = [];
            for (let i = 0; i < binaryString.length; i++) {
                array.push(binaryString.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], { type: "image/png" });
        },
        next: function()
        {
            let _this = this;

            let fileName = `contract_${this.draftProfile.name}.png`;
            const blob = _this.dataURLToBlob(this.imageUrl);
            const file = new File([blob], fileName, { type: "image/png" });
            this.delegateWithAddition.delegation_docs_file = file;
            // html2canvas(document.getElementById('contract')).then(canvas => {
            //     // _this.onSaveAs(canvas.toDataURL('image/png'), `contract.png`)      
            //     const blob = _this.dataURLToBlob(canvas.toDataURL('image/png'));
            //     const file = new File([blob], fileName, { type: "image/png" });
            //     this.files.delegation_docs_file = file;
            //     console.log(file);
            // })
            const sign_blob = _this.dataURLToBlob(this.signImageUrl);
            this.delegateWithAddition.signature_file = new File([sign_blob], "sign.png", { type: "image/png" });
        
            document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('next', 3)
        },
        back: function()
        {
            document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('next', 1)
        },
        onSaveAs: function(uri, filename) {
            var link = document.createElement('a');
            document.body.appendChild(link);
            link.href = uri;
            link.download= filename;
            link.click();
            document.body.removeChild(link);
        },
        signing: function()
        {
            this.isModal = true;
        },
        closeModal: function()
        {
            this.isModal = false;
        },
        saveSign: function(signature)
        {
            this.signImageUrl = signature;
            this.imageUrl = null;
            this.isModal = false;  
        },
        isEmptySign: async function(url)
        {
            const sign_blob = this.dataURLToBlob(url);
            const file = new File([sign_blob], "sign.png", { type: "image/png" });
            if (!file) return;

            const img = new Image();
            img.src = URL.createObjectURL(file);
            await img.decode();

            // canvas 생성
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;

            // 이미지 그리기
            ctx.drawImage(img, 0, 0);

            // 픽셀 데이터 가져오기
            const { data } = ctx.getImageData(0, 0, img.width, img.height);

            // 알파값 검사 (4번째 인덱스가 a 값)
            let hasOpaquePixel = false;
            for (let i = 3; i < data.length; i += 4) {
                if (data[i] > 0) { // a > 0인 픽셀이 존재
                hasOpaquePixel = true;
                break;
                }
            }

            if (hasOpaquePixel) {
                alert('이 PNG는 비어있지 않습니다.');
            } else {
                alert('이 PNG는 완전히 비어 있습니다 (모두 투명).');
            }
        },
        // onImageLoad: function()
        // {
        //     alert("load1")
        //     // this.updateButtonPosition();
        //     this.$nextTick(() => {
        //         requestAnimationFrame(() => {
        //             console.log('✅ 이미지가 화면에 완전히 렌더링됨');
        //             // 이 시점에서 안전하게 함수 실행 가능
        //             alert("load2")
        //             this.getImageUrl();
        //         });
        //     });
            
        // },
        updateButtonPosition() {
            const container = this.$refs.container;
            const button = this.$refs.button;

            // 이미지 크기에 따라 버튼의 위치를 조정 (가령 이미지의 30%, 40% 위치에 배치)
            const offsetX = container.clientWidth * 0.09; // 원하는 비율
            const offsetY = container.clientHeight * 0.08; // 원하는 비율

            button.style.right = `${offsetX}px`;
            button.style.bottom = `${offsetY}px`;
            button.style.width = `${offsetX}px`;
            button.style.height = `${offsetX}px`;
            button.style.fontSize = `${offsetX / 4}px`;


        },
    }
}
</script>

<style scoped>
    .contract {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        box-sizing: border-box;
        padding: 16px;
        position: relative;
        overflow-y: auto;
        height: 100dvh;
    }

    @media (min-width: 600px) {
        .contract {
            width: 600px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            box-sizing: border-box;
            padding: 15px;

            overflow-y: auto;
            height: 100dvh;
        }
    }


    .image-container {
        position: relative;
        display: inline-block;
        width: 600px; /* 원하는 크기로 설정 */
    }
    .responsive-image {
        width: 100%;
        height: auto;
    }

    .overlay-text {
        position: absolute;
        color: #000; /* 글씨 색상 */
        right: 26%;
        bottom: 12.6%;
        transform: translate(26%, 12.6%);
    }

    .overlay-button {
        position: absolute;
        bottom: 9%;
        right: 10%;
        border: 4px dotted black;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        z-index: 9999;
        width: 12%;
        aspect-ratio: 1/0.6;
        font-size: clamp(8px, 2vw, 14px);
    }

    .overlay-button-none {
        position: absolute;
        bottom: 9%;
        right: 10%;
    }

    .inner-image-year {
        position: absolute;
        bottom: 12.5%;
        right: 28%;
        transform: translate(28%, 12.5%);
        width: 8%;
        height: auto;
        padding:0;
        margin: 0;
    }

    .inner-image-name {
        position: absolute;
        top: 16.8%;
        left: 63.7%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 13px;
        z-index: 9999;
    }
    .inner-image-registration-number {
        position: absolute;
        top: 19.3%;
        left: 63.7%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 13px;
        z-index: 9999;
    }
    .inner-image-proxy-name {
        position: absolute;
        top: 21.9%;
        left: 63.7%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 13px;
        z-index: 9999;
    }
    .inner-image-proxy-birth {
        position: absolute;
        top: 24.4%;
        left: 63.7%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 13px;
        z-index: 9999;
    }
    .inner-image-proxy-relation {
        position: absolute;
        top: 26.9%;
        left: 63.7%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 13px;
        z-index: 9999;
    }
    .inner-image-phone-number {
        position: absolute;
        top: 29.4%;
        left: 50.7%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 13px;
        z-index: 9999;
    }

    .inner-image-start-1-year
    {
        position: absolute;
        bottom: 19.65%;
        left: 25.3%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 12px;
        z-index: 9999;
    }

    .inner-image-start-1-month
    {
        position: absolute;
        bottom: 19.65%;
        left: 34%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 12px;
        z-index: 9999;
    }
    
    .inner-image-start-1-day
    {
        position: absolute;
        bottom: 19.65%;
        left: 40%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 12px;
        z-index: 9999;
    }

    .inner-image-end-year
    {
        position: absolute;
        bottom: 19.65%;
        left: 52.3%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 12px;
        z-index: 9999;
    }

    .inner-image-end-month
    {
        position: absolute;
        bottom: 19.65%;
        left: 61%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 12px;
        z-index: 9999;
    }

    .inner-image-end-day
    {
        position: absolute;
        bottom: 19.65%;
        left: 67%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 12px;
        z-index: 9999;
    }

    .inner-image-start-2-year {
        position: absolute;
        bottom: 12.56%;
        left: 70%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 12px;
        z-index: 9999;
    }
    .inner-image-start-2-month {
        position: absolute;
        bottom: 12.56%;
        left: 79.8%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 12px;
        z-index: 9999;
    }
    .inner-image-start-2-day {
        position: absolute;
        bottom: 12.56%;
        left: 86%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 12px;
        z-index: 9999;
    }

    .inner-image-sign-name {
        position: absolute;
        bottom: 10.2%;
        left: 73%;
        padding:0;
        margin: 0;
        display: flex;
        font-size: 13px;
        z-index: 9999;
    }
    
    .img {
        width: 100%;
        height: 100%;
        object-fit:cover;
        opacity: -1;
        z-index: -1;
    }
    .text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        white-space: nowrap;
        z-index: 99999;
    }
    .text-top {
        position: absolute;
        top: 0%;
        left: 50%;
        transform: translate(-50%, 0%);
        white-space: nowrap;
    }
    /*  */
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
        margin-top: 30px;
    }
    .step {
        width: 100%;
        max-width: 600px;
    }
    .footer-button-area {
        position: fixed;
        bottom: 0;
        width: 100%;
        background: linear-gradient(0deg, #FFF 0%, rgba(255, 255, 255, 0.00) 255.33%);
        height: 124px;
        z-index: 9999;
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 0 16px;
        box-sizing: border-box;
        margin-left: -16px;
    }

    @media (min-width: 600px) {
        .footer-button-area {
            width: 600px;
        }
    }
    .button-back {
        height: 56px;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 48%;
        max-width: 247px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .button-sign {
        height: 56px;
        flex-shrink: 0;
        border-radius: 6px;
        background: #184FA1;
        color: var(--Gray-primary-color2, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 48%;
        max-width: 247px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .button-sign-active {
        height: 56px;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        color: var(--Gray-primary-color2, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 48%;
        max-width: 247px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .change {
        border-top: 1px solid black;
        width: 100%;
    }
    .reset-button {
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
        cursor: pointer;
    }
    .change-info-text {
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 128.571% */
        letter-spacing: -0.42px;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/revisit_contract/ContractNew.vue